'use client';
import { createContext, useContext } from 'react';
export const NotificationsContext = createContext(null);
NotificationsContext.displayName = 'NotificationsContext';
export const useNotifications = () => {
    const context = useContext(NotificationsContext);
    if (!context) {
        throw new Error('useNotifications must be used within a NotificationsProvider');
    }
    return context;
};
//# sourceMappingURL=NotificationsContextShared.js.map